import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';

function SubMenuAccountComponent() {
  const { t } = useTranslation();
  const history = useHistory();
  const { language } = useParams();
  const authUserData = JSON.parse(localStorage.getItem('authUserData'));
  const [isScrollUp, setIsScrollUp] = useState(false);
  const prevScrollY = useRef(0);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    if (authUserData?.token?.access_token === undefined) {
      history.push(`/${language}`);
    }
    // eslint-disable-next-line
  }, []);

  const handleGoPage = slug => {
    history.push(`/${language}/${slug}`);
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    currentScrollY >= 100 ? setIsScrollUp(true) : setIsScrollUp(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [prevScrollY]);

  return (
    <div id="subMenuAccount">
      <div className={`${isScrollUp ? 'sub-menu_backgr sub-menu_active-fixed' : 'sub-menu_backgr'}`}>
        <div className="container">
          <div className="d-flex">
            <div
              onClick={() => handleGoPage('manage-account/personal-detail')}
              className={`sub-menu_items ${window.location.href.includes(`/manage-account`) ? `sub-menu_active` : ''}`}
            >
              {t('manageAccount.label_manageAccount')}
            </div>
            <div
              onClick={() => handleGoPage('list-booking')}
              className={`sub-menu_items ${window.location.href.includes(`/list-booking`) ? `sub-menu_active` : ''}`}
            >
              {t('manageAccount.label_bookings')}
            </div>
            <div
              onClick={() => handleGoPage('favourites?pageIndex=1')}
              className={`sub-menu_items ${window.location.href.includes(`/favourites`) ? `sub-menu_active` : ''}`}
            >
              {t('manageAccount.label_favourite')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubMenuAccountComponent;
